import React, { Component } from "react"
import "../../SignIn/SignIn.scss"
import LoginSignUp from "../../../hoc/LoginSignUp/LoginSignUp"
import { selectIcon, SVG } from "../../../components/UI/selector"
import {
  FieldControl,
  FormBuilder,
  Validators,
  FieldGroup,
} from "react-reactive-form"
import { FormGroups } from "../../../components/ReusableComponents/FormGroups/FormGroups"
import { pattern } from "../../../services/subscriberService"
import { TextInput } from "../../../components/UI/FormInput/FormInput"
import { UniqueID } from "../../../services/CommonFunction"
import { forgotPassword } from "../../../services/CallApi"
import { ErrorUI } from "../../../components/UI/Modals/Modals"

class ForgotPassword extends Component {
  constructor(props) {
    super(props)
    this.state = { resetToken: null }
  }

  loginForm = FormBuilder.group({
    email: ["", [Validators.required, Validators.pattern(pattern.username)]],
  })

  handleSubmit = (e) => {
    e.preventDefault()
    if (this.loginForm.valid) {
      const data = {
        email: this.loginForm.value.email,
        /* password: this.loginForm.value.password,
        app_version: "0",
        timezone_offset: "0",
        device_type: "WEB",
        device_id: (+new Date()).toString() + UniqueID(),
        device_token: "0", */
      }
      forgotPassword(data).then((res) => {
        console.log(res)
        if (res.status) {
          if (res.data.password_reset_token) {
            ErrorUI(
              "Please open the link sent to your email address to reset your password."
            )
          } else {
            ErrorUI("No accounts found with this email.")
          }
        } else {
          ErrorUI(res.list, () => {
            forgotPassword(data)
          })
        }
      })
    }
  }

  goToSignUp = () => {
    this.props.history.push({ pathname: "/SignUp" })
  }

  render() {
    return (
      <div className="formDetailContainer">
        <FieldGroup
          control={this.loginForm}
          render={({ get, invalid }) => (
            <form onSubmit={this.handleSubmit}>
              <p className="redSubHeading">
                Need to reset your password? Enter your email address below.
              </p>
              <div className="textDiv">
                <img src={selectIcon("forgotPassword")} />
              </div>
              <FormGroups>
                <FieldControl
                  name="email"
                  render={TextInput}
                  meta={{
                    label: "Email address",
                    showLabel: false,
                    type: "email",
                    placeholder: "Email address",
                    placeHolderIcon: "emailInput",
                    valid: true,
                    showError: true,
                  }}
                />
              </FormGroups>
              <div className="submitDiv" style={{ justifyContent: "center" }}>
                <button
                  className={`${invalid ? "disabled" : "enabled"}`}
                  type="submit"
                >
                  <p>Continue</p>
                </button>
              </div>
            </form>
          )}
        />
      </div>
    )
  }
}

const headerDetail = {
  heading: null,
  subHeading1: "Join the best digital fitness",
  subHeading2: "experience now!",
  subHeading3: null,
  isLogoRequired: true,
}

const ForgotPasswordComponent = LoginSignUp(ForgotPassword, headerDetail)
export default ForgotPasswordComponent
